import React from "react";
import { Link } from "react-router-dom";

import {
  FiDribbble,
  FiFacebook,
  FiInstagram,
  FiLinkedin,
  FiMail,
  FiShoppingCart,
  FiTwitter,
} from "react-icons/fi";

export default function Footer() {
  return (
    <footer className="py-8 bg-slate-800 dark:bg-gray-900">
      <div className="container">
        <div className="grid md:grid-cols-12 items-center">
          <div className="md:col-span-3">
            <Link to="#" className="logo-footer text-white text-xl font-bold md:ms-0 mx-auto inline-block">
              Therapy Connect
            </Link>
          </div>

          <div className="md:col-span-5 md:mt-0 mt-8">
            <div className="text-center">
              <p className="text-gray-400">
                © {new Date().getFullYear()} Therapy Connect. Plataforma de
                gestión para profesionales del movimiento y la salud.
              </p>
              <p className="text-gray-400 mt-2">
                <Link to="/politica-privacidad" className="hover:text-white">
                  Política de privacidad
                </Link>
              </p>
            </div>
          </div>

          <div className="md:col-span-4 md:mt-0 mt-8">
            <ul className="list-none foot-icon ltr:md:text-right rtl:md:text-left text-center">
              <li className="inline">
                <Link
                  to="#"
                  className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"
                >
                  <FiShoppingCart
                    className="h-4 w-4 align-middle"
                    title="Demo"
                  />
                </Link>
              </li>

              <li className="inline">
                <Link
                  to="#"
                  className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"
                >
                  <FiDribbble
                    className="h-4 w-4 align-middle"
                    title="dribbble"
                  />
                </Link>
              </li>

              <li className="inline">
                <Link
                  to="#"
                  className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"
                >
                  <FiLinkedin
                    className="h-4 w-4 align-middle"
                    title="Linkedin"
                  />
                </Link>
              </li>

              <li className="inline">
                <Link
                  to="#"
                  className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"
                >
                  <FiFacebook
                    className="h-4 w-4 align-middle"
                    title="facebook"
                  />
                </Link>
              </li>

              <li className="inline">
                <Link
                  to="#"
                  className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"
                >
                  <FiInstagram className="h-4 w-4 align-middle" />
                </Link>
              </li>

              <li className="inline">
                <Link
                  to="#"
                  className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"
                >
                  <FiTwitter className="h-4 w-4 align-middle" title="twitter" />
                </Link>
              </li>

              <li className="inline">
                <Link
                  to="mailto:demo@therapyconnect.app"
                  className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-700 hover:border-red-500 rounded-md text-slate-300 hover:text-white hover:bg-red-500"
                >
                  <FiMail className="h-4 w-4 align-middle" title="email" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
